import React, { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { useDrop } from 'react-dnd';
import { ListItemTypes } from './ListItemTypes';
import ListItem from './ListItem';
import update from 'immutability-helper';
import '@spectrum-css/assetlist/dist/index-vars.css';

interface ListItemType {
  documentHashId: string;
  fileName: string;
  documentOrder: number;
}

interface ListProps {
  items: Array<ListItemType>;

  onMoveItem?: (documentHashId: string, documentOrder: number, items: Array<ListItemType>) => void;
  onRemoveItem?: (documentHashId: string) => void;
}

const List: FunctionComponent<ListProps> = (props) => {
  const [items, setItems] = useState(props.items);

  useEffect(() => {
    setItems(props.items);
  }, [props.items]);

  const findItem = useCallback(
    (id: string) => {
      const item = items.filter((i) => `${i.documentHashId}` === id)[0];
      return {
        item,
        index: items.indexOf(item),
      };
    },
    [items],
  );

  const moveItem = useCallback(
    (id: string, atIndex: number) => {
      const { item, index } = findItem(id);

      let newItems = update(items, {
        $splice: [
          [index, 1],
          [atIndex, 0, item],
        ],
      });

      newItems.map((value, index) => {
        value.documentOrder = index;
        return value;
      });

      setItems(newItems);

      if (props.onMoveItem) {
        props.onMoveItem(id, atIndex, newItems);
      }
    },
    [findItem, items, props],
  );

  const removeItem = useCallback(
    (documentHashId: string) => {
      if (props.onRemoveItem) {
        props.onRemoveItem(documentHashId);
      }
    },
    [props],
  );

  const [, drop] = useDrop(() => ({ accept: ListItemTypes.DOCUMENT }));

  return (
    <ul className="spectrum-AssetList" ref={drop}>
      {items.map((item) => (
        <ListItem
          key={item.documentHashId}
          documentHashId={`${item.documentHashId}`}
          fileName={item.fileName}
          documentOrder={item.documentOrder}
          moveItem={moveItem}
          findItem={findItem}
          removeItem={removeItem}
        />
      ))}
    </ul>
  );
};

List.defaultProps = {};

export default List;
